import { gql } from '@apollo/client';

export const GET_ONBOARDING_CONTEXT = gql`
  query GetOnboardingContext {
    getCurrentUser {
      id
      name
      email
      motivation
      retirement_timeline_bucket
      modernized_onboarding_completed
      approval_state
      pending_motivation
      transitionGoals { id name }
      company {
        id
        name
        branded_name
        business_type
        goals { id name }
        feature_types
      }
    }
  }
`;

export const COMPLETE_MODERNIZED_ONBOARDING = gql`
  mutation CompleteModernizedOnboarding(
    $motivation: String!
    $transitionGoalIds: [ID!]
    $retirementTimelineBucket: String!
  ) {
    completeModernizedOnboarding(
      motivation: $motivation
      transition_goal_ids: $transitionGoalIds
      retirement_timeline_bucket: $retirementTimelineBucket
    ) {
      id
      motivation
      retirement_timeline_bucket
      modernized_onboarding_completed
      approval_state
      pending_motivation
      transitionGoals { id name }
      company { id name branded_name business_type feature_types }
    }
  }
`;


